import { AbstractControl, ValidationErrors } from "@angular/forms";

export interface AbstractControlWithWarnings extends AbstractControl {
    warnings?: ValidationErrors | null;
}
